const settings = {
  baseAddress: "",
  googleOauthClientId: "",
};

export default settings;
